import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/hero/Hero";
import { Marquee } from "@/components/Marquee";
import { Flavors } from "@/components/Flavors";
import { Indulge } from "@/components/Indulge";
import { Contact } from "@/components/Contact";
import { scrollToId } from "@/components/SmoothScroll";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 300);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main>
      <Hero />
      <div className="relative z-10 -my-4"><Marquee /></div>
      <Flavors />
      <Indulge />
      <Contact />
    </main>
  );
}
